var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"HowItWorks"}},[_c('Hero',{attrs:{"src":"../assets/howItWorks/hero.jpg"}},[_c('h1',[_vm._v("Kaip tai veikia?")])]),_c('SectionReasons'),_c('SectionOrderSteps'),(!_vm.isAuth)?_c('FormSignupWide'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }